
import './App.css';

import { Environment, OrbitControls, Html, useProgress, useHelper, useGLTF, ScrollControls, Scroll } from '@react-three/drei';

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Canvas, useFrame, useLoader, useThree } from '@react-three/fiber'
import { Suspense, useEffect, useMemo, useRef, useState } from 'react';

import * as THREE from 'three'
import CameraControls from 'camera-controls'
import { Vector3 } from 'three';
import { Moon } from './components/models/moon';
import Renderif from './utils/renderif';
import Map from './map';
// import { Octahedron } from '../../components/models/octahedron';
// import { DirectionalLightHelper } from 'three';
// // import { useNavigate } from 'react-router-dom';
// import CameraPositionLogger from '../../components/helpers/camera_position_logger';
// import { Island } from '../../components/models/island';

import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './view/home';
import Single from './view/single';
import WebDevelopmentView from './view/web_development_view';
import SoftwareDevelopmentView from './view/software_development_view';
import BrandManagementView from './view/brand_management_view';
import AppSolutionsView from './view/app_solutions_view';

export default function App() {
  return (
    <BrowserRouter>
    <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/software-development' element={<SoftwareDevelopmentView></SoftwareDevelopmentView>}></Route>
        <Route path='/web-development' element={<WebDevelopmentView></WebDevelopmentView>}></Route>
        <Route path='/brand-management' element={<BrandManagementView></BrandManagementView>}></Route>
        <Route path='/app-solutions' element={<AppSolutionsView></AppSolutionsView>}></Route>
    </Routes>
    </BrowserRouter>

  )
}



